module.exports = __webpack_public_path__ + "img/13.e9dde42a.jpg";